import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of, pipe, combineLatest } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { RetryActions } from '../actions';
import { CoreFacade } from '../core.facade';

@Injectable()
export class RetryEffects {
  retryAllFaildActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RetryActions.retryAllFailedActions),
      switchMap(() => this.coreFacade.retryActions$.pipe(take(1))),
      pipe(
        switchMap((actions) => {
          if (actions.length > 0) {
            return [...actions, RetryActions.clearRetryFailedActions()];
          }
          return EMPTY;
        })
      )
    )
  );

  retrySpecificFailedActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RetryActions.retrySpecificActionTypes),
      switchMap((action) =>
        combineLatest([this.coreFacade.retryActions$, of(action)]).pipe(take(1))
      ),
      pipe(
        switchMap(
          ([retryActions, { types }]: [Action[], { types: string[] }]) => {
            return [
              ...retryActions.filter((action) => types.includes(action.type)),
              RetryActions.clearRetryFailedActions(),
            ];
          }
        )
      )
    )
  );

  onrouteChange = createEffect(
    () =>
      this.router.events.pipe(
        tap((event: Event) => {
          if (event instanceof NavigationEnd && event.id !== 1) {
            this.coreFacade.clearRetryActions();
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private coreFacade: CoreFacade,
    private router: Router
  ) {}
}
